/**
 * @fileOverview This file contains the implementation of the AgendaToolbar component
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

//#region Imports
import { Grid, IconButton, Button, Typography } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid-pro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-regular-svg-icons";
import moment from "moment";
import { useTranslationHook } from "../../hooks/UseTranslationHook";
//#endregion

const AgendaToolbar = ({ weekStart, weekEnd, setWeekStart, setWeekEnd }) => {
  const { agendaToday } = useTranslationHook();

  /**
   * Updates `weekStart` and `weekEnd` to the start and end of the previous week.
   */
  const handlePrevWeek = () => {
    setWeekStart((prevWeekStart) => moment(prevWeekStart).subtract(1, "week"));
    setWeekEnd((prevWeekEnd) => moment(prevWeekEnd).subtract(1, "week"));
  };

  /**
   * Updates `weekStart` and `weekEnd` to the start and end of the next week.
   */
  const handleNextWeek = () => {
    setWeekStart((prevWeekStart) => moment(prevWeekStart).add(1, "week"));
    setWeekEnd((prevWeekEnd) => moment(prevWeekEnd).add(1, "week"));
  };

  /**
   * Updates `weekStart` and `weekEnd` to the start and end of the current week.
   */
  const handleToday = () => {
    setWeekStart(moment().startOf("week"));
    setWeekEnd(moment().endOf("week"));
  };

  return (
    <GridToolbarContainer>
      <Grid container style={{ justifyContent: "space-between" }}>
        <Grid item>
          <IconButton onClick={handlePrevWeek} size="small">
            <FontAwesomeIcon icon={faChevronLeft} className="icon" />
          </IconButton>
          <Button>
            <Typography>
              {weekStart.format("DD/MM/YYYY")} - {weekEnd.format("DD/MM/YYYY")}
            </Typography>
          </Button>
          <IconButton onClick={handleNextWeek} size="small">
            <FontAwesomeIcon icon={faChevronRight} className="icon" />
          </IconButton>
        </Grid>
        <Grid item>
          <Button onClick={handleToday} size="small">
            {agendaToday}
          </Button>
        </Grid>
      </Grid>
    </GridToolbarContainer>
  );
};

export default AgendaToolbar;
